<template>
  <v-dialog v-model="errorDialog" persistent width="500">
    <v-card pa-5>
      <v-card-title class="headline">{{errorTitle && errorTitle !== '' ? errorTitle : 'Error'}}</v-card-title>
      <v-card-text><div v-html="errorMessage"/></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="errorDialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ErrorDialog',
  data () {
    return {
      errorDialog: false,
      errorTitle: '',
      errorMessage: ''
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ErrorDialog.vue